module.exports = __webpack_public_path__ + "static/media/ico_error.6e691c10.svg";